/**
 * @generated SignedSource<<e136d4fdb573b664ca8a45026440c6cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilteredSurveyInput = {
  PIISurveys?: boolean | null;
  historicSurveys?: boolean | null;
  trackingParams?: ReadonlyArray<TrackingParam | null> | null;
  webcamSurveys?: boolean | null;
};
export type TrackingParam = {
  key: string;
  value: string;
};
export type SurveyListRefetchQuery$variables = {
  input: FilteredSurveyInput;
};
export type SurveyListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SurveyListFragment_surveysRef">;
};
export type SurveyListRefetchQuery = {
  response: SurveyListRefetchQuery$data;
  variables: SurveyListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SurveyListRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "SurveyListFragment_surveysRef"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SurveyListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Survey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrencyAmount",
                    "kind": "LinkedField",
                    "name": "rewardAmount",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subUnitAmount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LockedSurveyInfo",
                    "kind": "LinkedField",
                    "name": "lockedInfo",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DurationDetails",
                    "kind": "LinkedField",
                    "name": "durationDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "providerDuration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AdminSurveyData",
                    "kind": "LinkedField",
                    "name": "adminData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rankScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyGuid",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51a63930365913430ce15cbd3a49ae7d",
    "id": null,
    "metadata": {},
    "name": "SurveyListRefetchQuery",
    "operationKind": "query",
    "text": "query SurveyListRefetchQuery(\n  $input: FilteredSurveyInput!\n) {\n  ...SurveyListFragment_surveysRef_2VV6jB\n}\n\nfragment SurveyCard_survey on Survey {\n  id\n  iconUrl\n  rewardAmount {\n    subUnitAmount\n  }\n  lockedInfo {\n    title\n  }\n  title\n  url\n  status\n  supportId\n  durationDetails {\n    providerDuration\n  }\n  tags\n  adminData {\n    rankScore\n    surveyGuid\n  }\n}\n\nfragment SurveyListFragment_surveysRef_2VV6jB on Query {\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    edges {\n      node {\n        id\n        tags\n        status\n        ...SurveyCard_survey\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ee5a54a8a4d7adfa9ff0f1d07f41ea0";

export default node;
